import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { GetAction } from './GetAction'
import {
  isExternalUrl,
  menuHref,
  mergeMenuWithCmsPages,
  pagesToMenuItems,
} from '../utils/pageMenu'
import { mediaUrl, staticAssetUrl } from '../utils/mediaUrl'

const DEFAULT_SETTINGS = {
  website_name: 'श्री आचार्य विद्यासागर जीवदया ट्रस्ट',
  footer_address:
    "फ्लैट नंबर १, वीतराग,\nसेक. २४, प्लाट नंबर ६, निगड़ी प्राधिकरण,\nनिगड़ी, पुणे - ४११०४४",
  footer_contact: '०२० २७६५३१५४',
  logo_path: staticAssetUrl('assets/images/logo.png'),
}

function FooterMenuLink({ item }) {
  const href = menuHref(item.url)
  if (isExternalUrl(href) || Number(item.open_new_tab) === 1) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {item.label}
      </a>
    )
  }
  return <Link to={href}>{item.label}</Link>
}

function Footer() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS)
  const [footerLinks, setFooterLinks] = useState([])

  useEffect(() => {
    GetAction('get', {}, 'settings/get').then((data) => {
      if (data?.status === 'success' && data.response) {
        setSettings({
          website_name: data.response.website_name || DEFAULT_SETTINGS.website_name,
          footer_address: data.response.footer_address || DEFAULT_SETTINGS.footer_address,
          footer_contact: data.response.footer_contact || DEFAULT_SETTINGS.footer_contact,
          logo_path: mediaUrl(data.response.logo_path) || DEFAULT_SETTINGS.logo_path,
        })
      }
    })

    let cancelled = false
    ;(async () => {
      const [menuData, pagesData] = await Promise.all([
        GetAction('get', { location: 'footer' }, 'menu/list'),
        GetAction('get', { menu_location: 'footer' }, 'pages/pagesList'),
      ])
      if (cancelled) return

      const pages =
        pagesData?.status === 'success' && Array.isArray(pagesData.response)
          ? pagesData.response
          : []

      // Prefer Manage → Menus, but always surface Active CMS footer pages too
      if (
        menuData?.status === 'success' &&
        Array.isArray(menuData.response) &&
        menuData.response.length > 0
      ) {
        setFooterLinks(mergeMenuWithCmsPages(menuData.response, pages))
        return
      }

      setFooterLinks(pagesToMenuItems(pages))
    })()

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <footer>
      <div className="container">
        {footerLinks.length > 0 ? (
          <nav className="footer-menu" aria-label="Footer">
            <ul className="footer-menu-list">
              {footerLinks.map((item, idx) => (
                <li key={`${item.url}-${idx}`}>
                  <FooterMenuLink item={item} />
                </li>
              ))}
            </ul>
          </nav>
        ) : null}
        <div className="row">
          <div className="col-12 col-sm-12 col-md col-lg col-xl">
            <img
              src={settings.logo_path}
              style={{ float: 'left', maxHeight: 70, maxWidth: 120, objectFit: 'contain' }}
              alt="logo"
            />
            <div className="margintop46" style={{ whiteSpace: 'pre-line' }}>
              {settings.website_name}
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md col-lg col-xl">
            <div>
              <img
                src={staticAssetUrl('assets/images/icons/icon_location.png')}
                width="35px"
                className="marginb10"
                alt="location"
              />
            </div>
            <p style={{ whiteSpace: 'pre-line' }}>{settings.footer_address}</p>
          </div>
          <div className="col-12 col-sm-12 col-md col-lg col-xl">
            <div>
              <img
                src={staticAssetUrl('assets/images/icons/icon_phone.png')}
                width="35px"
                className="marginb10"
                alt="phone"
              />
            </div>
            <p>{settings.footer_contact}</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
